module.exports = __webpack_public_path__ + "img/icon1.5a909924.png";